import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "text-center mb-10" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "text-dark mb-3" }, "Registration")
], -1)
const _hoisted_2 = {
  class: "card mb-5 mb-xl-10",
  style: {"margin-top":"15%"}
}
const _hoisted_3 = {
  id: "employee_information",
  class: "collapse show"
}
const _hoisted_4 = { class: "collapse show" }
const _hoisted_5 = { class: "card-body border-top p-9" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "text-center" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "form-label fs-3" }, "Register as a Trainee")
], -1)
const _hoisted_7 = { class: "row mt-3" }
const _hoisted_8 = { class: "col-md-12" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "OTP", -1)
const _hoisted_10 = { class: "text-center" }
const _hoisted_11 = ["data-kt-indicator"]
const _hoisted_12 = {
  key: 0,
  class: "indicator-label"
}
const _hoisted_13 = {
  key: 1,
  class: "indicator-progress"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createBlock(_component_Form, {
    onSubmit: _cache[1] || (_cache[1] = ($event: any) => (_ctx.otpFormSubmit())),
    class: "form",
    "validation-schema": _ctx.TraineeOtpSchema
  }, {
    default: _withCtx(() => [
      _hoisted_1,
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _hoisted_9,
                  _createVNode(_component_Field, {
                    modelValue: _ctx.user_otp,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.user_otp) = $event)),
                    type: "text",
                    name: "otp",
                    class: "form-control form-control-lg"
                  }, null, 8, ["modelValue"]),
                  _createVNode(_component_ErrorMessage, {
                    name: "otp",
                    class: "fv-plugins-message-container invalid-feedback"
                  })
                ])
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("button", {
          "data-kt-indicator": _ctx.loading ? 'on' : null,
          class: "btn btn-lg btn-primary w-100 mb-5",
          type: "submit"
        }, [
          (!_ctx.loading)
            ? (_openBlock(), _createElementBlock("span", _hoisted_12, " Continue "))
            : _createCommentVNode("", true),
          (_ctx.loading)
            ? (_openBlock(), _createElementBlock("span", _hoisted_13, [
                _createTextVNode(" Please wait... "),
                _hoisted_14
              ]))
            : _createCommentVNode("", true)
        ], 8, _hoisted_11)
      ])
    ]),
    _: 1
  }, 8, ["validation-schema"]))
}